/**
 * Compares two named object
 * @param name1 the name for the first object
 * @param name2 the name for the second object
 * @return -1 id name1 < name2, 0, if name1 === name2, 1 if name1 > name2
 */
export const compareByName = ({ name: name1 }: { name: string }, { name: name2 }: { name: string }): number => name1.localeCompare(name2)
